export const SYS_MENU_SAVE = 'SYS_MENU_SAVE';
export const SYS_MENU_SAVE_TREE = 'SYS_MENU_SAVE_TREE';
export const SYS_MENU_SAVE_SELECTED = 'SYS_MENU_SAVE_SELECTED';
export const SYS_MENU_SAVE_PERM_LIST = 'SYS_MENU_SAVE_PERM_LIST';

